import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Box, Button, Circle, Input, Radio, RadioGroup, Stack, Text } from "@chakra-ui/react";
import { useEffect, useRef } from "react";
import { ReactComponent as PlusIcon } from '../../svg/plus.svg'
import { ReactComponent as MinusIcon } from '../../svg/minus.svg'
import { useState } from "react";
import { useSelector } from "react-redux";
import { addChoice, deleteChoice, updateChoice, updateQuestion } from "../../redux/api_calls/apiCalls";
import ConfirmAlertDialog from "../common/ConfirmAlertDialog";

export default function EditDialog({ isOpen, onClose, method, question, options, existingChoice }) {
    const cancelRef = useRef()
    const [editedOptions, setEditedOptions] = useState(options)
    const [radioButton, setRadioButton] = useState(options.find(option => option.is_right_choice === 'Y')?.choice || null)
    const [editQuestionError, setEditQuestionError] = useState(null)
    const [questionText, setQuestionText] = useState(question.question_title)
    const [isLoading, setIsLoading] = useState(false)
    const [isConfirmOpen, setIsConfirmOpen] = useState(false)
    const [hoverPosition, setHoverPosition] = useState(null)

    const editState = useSelector(state => state.editState)

    const onConfirmClose = () => setIsConfirmOpen(false)

    const confirmAlertCloseHandler = () => {
        setIsConfirmOpen(false)
        onClose()
    }

    useEffect(() => {
        if(isOpen){
            setEditedOptions(options)
            setQuestionText(question.question_title)
            setRadioButton(options.find(option => option.is_right_choice === 'Y')?.choice || null)
        }
        else{
            setEditedOptions(null)
            setQuestionText("")
            setRadioButton(null)
        }
        // eslint-disable-next-line
    },[isOpen])

    const removeOptionHandler = (id) => {
        let newOptions = [...editedOptions]
        newOptions.splice(id, 1)
        setEditedOptions(newOptions)
    }


    const addOptionHandler = (id) => {
        let newOptions = editedOptions.slice(0, id + 1).concat([{ is_right_choice: 'N', choice: '', status: 'Y' }, ...editedOptions.slice(id + 1)])
        setEditedOptions(newOptions)
    }

    const changeHandler = (e, id) => {
        let newOptions = [...editedOptions]
        newOptions[id].choice = e.target.value
        setRadioButton(newOptions.find(options => options.is_right_choice === 'Y').choice)
        setEditedOptions(newOptions)
    }

    const validateEditQuestion = () => {
        let error = null
        if (questionText.length === 0) {
            error = 'Question Field cannot be empty!'
        }
        else if (editedOptions.some(option => option.choice.length === 0)) {
            error = 'One or more option fields are empty!'
        }

        else if (editedOptions.length < 2) {
            error = 'Atleast 2 options should be provided!'
        }
        else if (!radioButton) {
            error = 'Correct answer is not provided!'
        }
        if (error) {
            setEditQuestionError(error)
            return false
        }
        else {
            return true
        }
    }

    const editQuestionInDB = async (currentOptions) => {
        let errorFound = false
        setIsLoading(true)
        let choicesToAdd = currentOptions.filter(choice => !choice.id)
        if (choicesToAdd.length) {
            try {
                await addChoice(choicesToAdd, question.id)
            }
            catch (error) {
                setEditQuestionError(error.message)
                errorFound = true
            }
        }
        let choicesToDelete = options.filter(choice => !currentOptions.some(newChoice => newChoice.id === choice.id))
        if (choicesToDelete.length) {
            try {
                await deleteChoice(choicesToDelete)
            }
            catch (error) {
                setEditQuestionError(error.message)
                errorFound = true
            }
        }
        let choicesToUpdate = currentOptions.filter(choice => existingChoice.some(oldChoice => (oldChoice.id === choice.id && oldChoice.choice !== choice.choice) || (oldChoice.id === choice.id && oldChoice.is_right_choice !== choice.is_right_choice)))
        if (choicesToUpdate.length) {
            try {
                await updateChoice(choicesToUpdate)
            }
            catch (error) {
                setEditQuestionError(error.message)
                errorFound = true
            }
        }
        if (questionText !== question.question_title) {
            try {
                updateQuestion(question.id, { ...question, question_title: questionText, no_of_choices: editedOptions.length })
            }
            catch (error) {
                setEditQuestionError(error.message)
                errorFound = true
            }
        }
        setIsLoading(false)
        return !errorFound
    }

    const editQuestionHandler = async () => {
        if (!validateEditQuestion()) {
            return
        }
        else {
            let currentOptions = editedOptions.map(option => option.choice === radioButton ? { ...option, is_right_choice: 'Y' } : { ...option, is_right_choice: 'N' })
            console.log(currentOptions)
            if (editState.flag) {
                let result = await editQuestionInDB(currentOptions)
                if (result) {
                    method({ question: { ...question, question_title: questionText }, choices: currentOptions })
                }
            }
            else {
                method({ question: { ...question, question_title: questionText }, choices: currentOptions })
            }
        }
    }

    const cancelHandler = () => {
        if (editState.flag) {
            setIsConfirmOpen(true)
        }
        else {
            onClose()
        }
    }

    return (
        <AlertDialog
            isOpen={isOpen}
            leastDestructiveRef={cancelRef}
            onClose={onClose}
            isCentered
            size='2xl'
            closeOnOverlayClick={false}
        >

            <AlertDialogOverlay>
                <AlertDialogContent>
                    <AlertDialogHeader fontSize="lg" fontWeight="bold">
                        Edit Question
                    </AlertDialogHeader>

                    <AlertDialogBody>

                        <Box p='1.5rem' position='relative' width='100%' borderRadius='lg' bg='white' boxShadow='md' d='flex' flexDir='column' justifyContent={['center', 'center', 'flex-start', 'flex-start']} mt='2rem'>
                            <Input
                                variant='flushed'
                                focusBorderColor='none'
                                placeholder='Enter question here'
                                bg='white' style={{ fontFamily: 'Mulish, sans-serif' }}
                                fontSize='16px'
                                value={questionText}
                                onChange={(e) => setQuestionText(e.target.value)}
                            />
                            <RadioGroup
                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                fontSize='16px'
                                onChange={setRadioButton}
                                value={radioButton || -1}
                                colorScheme='switch'
                            >
                                <Stack direction="column" onMouseOut={() => setHoverPosition(null)}>
                                    {editedOptions &&
                                        editedOptions.map((choice, idx) => <Box
                                            d='flex'
                                            style={{ gap: '1rem' }}
                                            key={idx}
                                            justifyContent='flex-start'
                                            alignItems='center'
                                            onMouseOver={() => setHoverPosition(idx)}
                                        >
                                            <Radio value={editedOptions[idx].choice.length ? editedOptions[idx].choice : idx}></Radio>
                                            <Input
                                                id={`text${idx}`}
                                                variant='flushed'
                                                width='40%'
                                                placeholder='Enter option here'
                                                bg='white'
                                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                                fontSize={['12px', '13px', '14px', '16px']}
                                                focusBorderColor='none'
                                                value={editedOptions[idx].choice}
                                                onChange={(e) => {
                                                    changeHandler(e, idx)
                                                    setEditQuestionError(null)
                                                }}
                                            />
                                            <Box d='flex' flexGrow='1' opacity={hoverPosition === idx ? '1' : '0'} alignItems='center' transition='opacity 200ms ease'>
                                                <Circle size='18px' mr='2' cursor='pointer'>
                                                    <MinusIcon fill='#666666' onClick={() => removeOptionHandler(idx)} />
                                                </Circle>
                                                <Circle size='18px' cursor='pointer'>
                                                    <PlusIcon fill='#666666' onClick={() => addOptionHandler(idx)} />
                                                </Circle>
                                            </Box>
                                        </Box>
                                        )
                                    }
                                </Stack>
                            </RadioGroup>
                        </Box>
                        {
                            editQuestionError && <Text style={{ fontFamily: 'Mulish, sans-serif' }} color='red.500' fontSize='sm'>{editQuestionError}</Text>
                        }
                    </AlertDialogBody>

                    <AlertDialogFooter>
                        <Button ref={cancelRef} onClick={cancelHandler} disabled={isLoading}>
                            Cancel
                        </Button>
                        <Button colorScheme="switch" onClick={editQuestionHandler} ml={3} isLoading={isLoading} loadingText='Updating...'>
                            Update
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
            <ConfirmAlertDialog isOpen={isConfirmOpen} onClose={onConfirmClose} text={'Abort Editing Question'} message={'Are you sure? All changes will be lost! This action cannot be undone!'} method={confirmAlertCloseHandler} />
        </AlertDialog>
    )
}